import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useIconProps } from '../useIconProps';

var Savings = function Savings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M51.241 46H21.005a18.672 18.672 0 1121.848-5.949.75.75 0 101.19.912A20.163 20.163 0 1017.655 46H4.767a.75.75 0 000 1.5h46.474a.75.75 0 000-1.5z M33.223 28.866a3.057 3.057 0 00-1.968-1.825 4.2 4.2 0 00-2.146-.118l-1.243-3.36a2.639 2.639 0 011.136.1 1.592 1.592 0 011.038.923.75.75 0 101.406-.521 3.059 3.059 0 00-1.968-1.825 4.221 4.221 0 00-2.146-.118l-.427-1.153a.75.75 0 00-1.407.52l.427 1.154a4.2 4.2 0 00-1.552 1.487 2.969 2.969 0 001.661 4.491 4.2 4.2 0 002.147.119l1.243 3.36a2.624 2.624 0 01-1.136-.1 1.59 1.59 0 01-1.038-.924.75.75 0 10-1.406.521 3.06 3.06 0 001.968 1.826 4.035 4.035 0 001.28.2 4.492 4.492 0 00.865-.091l.451 1.22a.749.749 0 00.7.49.76.76 0 00.26-.047.75.75 0 00.443-.964l-.451-1.218a3.523 3.523 0 001.863-4.147zM26.511 27.2a1.477 1.477 0 01-.851-2.3 2.647 2.647 0 01.8-.814l1.187 3.214a2.638 2.638 0 01-1.136-.1zm4.321 4.382l-1.189-3.213a2.624 2.624 0 011.136.1 1.585 1.585 0 011.037.923 1.958 1.958 0 01-.984 2.187z"
  }));
};

Savings.displayName = 'Savings';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Savings.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Savings;